export var IdQuestIntrosPointerDirection;
(function (IdQuestIntrosPointerDirection) {
    IdQuestIntrosPointerDirection[IdQuestIntrosPointerDirection["None"] = 0] = "None";
    IdQuestIntrosPointerDirection[IdQuestIntrosPointerDirection["Left"] = 1] = "Left";
    IdQuestIntrosPointerDirection[IdQuestIntrosPointerDirection["Right"] = 2] = "Right";
})(IdQuestIntrosPointerDirection || (IdQuestIntrosPointerDirection = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/quest-intros/IdQuestIntrosPointerDirection.ts
// module id = 2889
// module chunks = 3